import { render, staticRenderFns } from "./SubjectsCreate.vue?vue&type=template&id=9fc83c5c&"
import script from "./SubjectsCreate.vue?vue&type=script&lang=js&"
export * from "./SubjectsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports